import { render, staticRenderFns } from "./humanResources.vue?vue&type=template&id=e8763324&scoped=true"
import script from "./humanResources.vue?vue&type=script&lang=js"
export * from "./humanResources.vue?vue&type=script&lang=js"
import style0 from "./humanResources.vue?vue&type=style&index=0&id=e8763324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8763324",
  null
  
)

export default component.exports